import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@ui/atoms/Button';
import I18n from '@utils/i18n';

import TagsGridContext from '../context';

// IP-15330: row action for the tags grid.
//
// Quimby Button (Atoms/Button, default variant) rather than the hand-rolled
// `a.qmb-control--icon` this used to be — that class is not a component and had
// to be recoloured by hand because it inherited the grid's link colour.
function ActionsCell({ item }) {
  const { canEdit, onOpenTag } = useContext(TagsGridContext);
  const label = I18n.t('generic.edit');

  if (!canEdit) return null;

  return (
    <Button title={label} aria-label={label} onClick={() => onOpenTag(item.id)}>
      <i className="fa-light fa-pencil" aria-hidden="true" />
    </Button>
  );
}

ActionsCell.propTypes = {
  item: PropTypes.shape({ id: PropTypes.number.isRequired }).isRequired
};

export default ActionsCell;
